'use client'

import { STORAGE_KEYS } from '@/core/constants/storage-keys'
import { storageService } from '@/core/services/storage'
import { create } from 'zustand'

type CookiesState = {
  cookiesConsented: boolean
  acceptCookies: () => void
  rejectCookies: () => void
}

export const useCookiesStore = create<CookiesState>(set => ({
  cookiesConsented:
    storageService.getItem(STORAGE_KEYS.cookiesConsented) === 'true',

  acceptCookies: () => {
    storageService.setItem(STORAGE_KEYS.cookiesConsented, 'true')
    set({ cookiesConsented: true })
  },

  rejectCookies: () => {
    storageService.removeItem(STORAGE_KEYS.cookiesConsented)
    set({ cookiesConsented: false })
  },
}))
